import React, { SyntheticEvent } from "react";
import { handleThumbnailError } from "@components/asset/modal/tabs/edit/helpers";

interface AttachmentImageProps {
  assetName: string;
  attachmentCount: number;
  attachmentExtension: string;
  src: string;
}

const AttachmentThumbnail = (props: AttachmentImageProps): JSX.Element => (
  <div className="edit-tab-sidebar-attachment-container">
    <div className="edit-tab-sidebar-attachment-image-container">
      <img
        alt={props.assetName}
        className="edit-tab-sidebar-attachment-image"
        onError={(e: SyntheticEvent<HTMLImageElement, Event>): void => handleThumbnailError(
          e, props.attachmentExtension, props.assetName, true /* isLargeView */
        )}
        src={props.src}
      />
    </div>
    <div className="edit-tab-sidebar-attachment-asset-details">
      <span className="asset-name">{props.assetName}</span>
      <div className="file-type-pill">
        <span aria-label="hidden" className="bff-paperclip attachment-count" />
        <span className="count">{props.attachmentCount}</span>
      </div>
    </div>
  </div>
);

export default AttachmentThumbnail;
